import { RouterProvider } from 'react-router-dom';
import { TolgeeProvider } from '@tolgee/react';
import { tolgee } from './utils/tolgee';

// routing
import router from 'routes';

// project imports
import Locales from 'ui-component/Locales';
import NavigationScroll from 'layout/NavigationScroll';
// import RTLLayout from 'ui-component/RTLLayout';
import Snackbar from 'ui-component/extended/Snackbar';
import ThemeCustomization from 'themes';
import Notistack from 'ui-component/third-party/Notistack';

// auth provider
import { JWTProvider as AuthProvider } from 'contexts/JWTContext';
// import { FirebaseProvider as AuthProvider } from 'contexts/FirebaseContext';
// import { AWSCognitoProvider as AuthProvider } from 'contexts/AWSCognitoContext';
// import { Auth0Provider as AuthProvider } from 'contexts/Auth0Context';

// ==============================|| APP ||============================== //

// Wrapper component to access auth context
const AppContent = () => {
    return (
        <>
            <Notistack>
                <RouterProvider router={router} />
                <Snackbar />
            </Notistack>
        </>
    );
};

const App = () => (
    <TolgeeProvider tolgee={tolgee} fallback="Loading...">
        <ThemeCustomization>
            {/* RTL layout */}
            {/* <RTLLayout> */}
            <Locales>
                <NavigationScroll>
                    <AuthProvider>
                        <AppContent />
                    </AuthProvider>
                </NavigationScroll>
            </Locales>
            {/* </RTLLayout> */}
        </ThemeCustomization>
    </TolgeeProvider>
);

export default App;
